import { type ReactNode } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { IconButton } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { BillingPath } from 'entities/ExportRouters'
import { BillingRoutes } from 'pages/settings/pages/billing/route/type'
import { SettingsRoutes } from 'pages/settings/route/type'
import styles from './styles.module.scss'

type IBillingViewProps = {
  children?: ReactNode
}

export const ViewPageLayout = observer(({ children }: IBillingViewProps) => {
  const location = useLocation()
  const isUpgradePage = location.pathname.includes(BillingRoutes.upgrade)
  const isStandaloneUpgrade =
    location.pathname === `/${SettingsRoutes.root}/${BillingRoutes.upgrade}`

  const handleClose = () => {
    const path = isStandaloneUpgrade
      ? `/${SettingsRoutes.root}/${SettingsRoutes.general}`
      : `/${BillingPath.root}`

    uiStore.changeRouteViaVue({ path })
  }

  return (
    <div className={styles.wrapper}>
      {isUpgradePage && (
        <div className={styles.closeIconWrapper}>
          <IconButton
            className={styles.closeIcon}
            ariaLabel='close_setting'
            icon='close'
            size='medium'
            variant='icon'
            color='tertiary'
            onClick={handleClose}
          />
        </div>
      )}
      <div className={styles.container}>
        <div className={styles.content}>{children ?? <Outlet />}</div>
      </div>
    </div>
  )
})
